/* ==========================================================================
   MAISON NOIR & CO — Live HEADER/HERO switcher (DEV / PREVIEW ONLY)
   The home renders 3 header variants stacked: split, spotlight, whoosh.
   This shows ONE at a time so the founder can compare and pick a winner.
   Choice persists. Never shown live (env-gated). When a winner is chosen,
   the two unused sections are removed from templates/index.json.
   ========================================================================== */
(function () {
  'use strict';

  // Section shopify ids assigned in templates/index.json
  var VARIANTS = [
    { id: 'split',     name: 'Split',     mood: 'Copy left · product right',   sectionId: 'mn_header_split' },
    { id: 'spotlight', name: 'Spotlight', mood: 'Headline behind product',     sectionId: 'mn_header_spotlight' },
    { id: 'whoosh',    name: 'Whoosh',    mood: 'Product flies up over text',  sectionId: 'mn_header_whoosh', klass: 'mn-whoosh' }
  ];

  var STORE_KEY = 'mn-header-choice';
  var DEFAULT = 'whoosh';

  function sectionEl(v) {
    // Primary: Shopify wraps template sections as #shopify-section-<key>.
    var el = document.getElementById('shopify-section-' + v.sectionId);
    if (el) return el;
    // Fallback 1: some templates prefix the key (e.g.
    // shopify-section-template--123__mn_header_split), so match by suffix.
    var all = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < all.length; i++) {
      var id = all[i].id;
      if (id === 'shopify-section-' + v.sectionId ||
          id.slice(-(v.sectionId.length + 2)) === '__' + v.sectionId ||
          id.slice(-(v.sectionId.length + 1)) === '-' + v.sectionId) {
        return all[i];
      }
    }
    // Fallback 2: match by the section's own distinguishing wrapper class.
    if (v.klass) {
      var byClass = document.querySelector('.' + v.klass);
      if (byClass) {
        var wrap = byClass.closest('[id^="shopify-section-"]');
        return wrap || byClass;
      }
    }
    return null;
  }

  function apply(id) {
    var found = 0;
    VARIANTS.forEach(function (v) {
      var el = sectionEl(v);
      if (el) {
        found++;
        el.style.setProperty('display', (v.id === id) ? '' : 'none', 'important');
      }
    });
    if (found === 0 && window.console) {
      // Diagnostic: dump the section ids actually present so we can map them.
      var ids = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (n) { ids.push(n.id); });
      console.warn('[mn-header-switcher] matched 0 header sections. Present section ids:', ids);
    }
    try { localStorage.setItem(STORE_KEY, id); } catch (e) {}
    markActive(id);
    var cur = document.querySelector('[data-mn-hs-current]');
    var chosen = VARIANTS.filter(function (v) { return v.id === id; })[0];
    if (cur && chosen) cur.textContent = chosen.name;
    // Re-trigger reveals in the now-visible header
    var el = sectionEl(chosen || {});
    if (el && window.IntersectionObserver) {
      el.querySelectorAll('.mn-reveal').forEach(function (r) { r.classList.add('is-inview'); });
    }
  }

  function markActive(id) {
    var btns = document.querySelectorAll('.mn-hs__opt');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].dataset.id === id ? 'true' : 'false');
    }
  }

  function isPreviewEnv(root) {
    try {
      var host = location.hostname;
      if (host === '127.0.0.1' || host === 'localhost') return true;
      var qs = location.search || '';
      if (qs.indexOf('preview_theme_id') !== -1 || qs.indexOf('_fd=') !== -1 || qs.indexOf('_ab=') !== -1) return true;
      if (window.self !== window.top && document.referrer.indexOf('/admin') !== -1) return true;
      if (root && root.getAttribute('data-mn-liquid-preview') === 'true') return true;
    } catch (e) {}
    return false;
  }

  function build() {
    var root = document.querySelector('[data-mn-header-switcher]');
    if (!root) return;
    if (!isPreviewEnv(root)) {
      // Live site: the winner (whoosh) is the only variant left in the
      // template, so never hide anything — the switcher is dev-only.
      return;
    }
    root.hidden = false;

    var toggle = root.querySelector('.mn-hs__toggle');
    var panel = root.querySelector('.mn-hs__panel');
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });

    var list = root.querySelector('[data-mn-hs-list]');
    VARIANTS.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mn-hs__opt';
      b.dataset.id = v.id;
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML =
        '<span class="mn-ps__opt-text">' +
          '<span class="mn-ps__opt-name">' + v.name + '</span>' +
          '<span class="mn-ps__opt-mood">' + v.mood + '</span>' +
        '</span>';
      b.addEventListener('click', function () { apply(v.id); });
      list.appendChild(b);
    });

    var saved = DEFAULT;
    try { saved = localStorage.getItem(STORE_KEY) || DEFAULT; } catch (e) {}
    apply(saved);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
